module.exports = { src: __webpack_public_path__ + "media/spot-error.ccd4bba1.svg", width: 160, height: 160 };